import type { CustomField } from '@lub0v/santa-utils';
import type { NewBoxDraft } from '@src/pages/NewBoxPage/draft';
import type { GameCopySource } from './gameCopyAnalytics';

const KEY = 'ss:copy-game:return:v1';
export interface CopyGameDraft {
  userId: number;
  sourceKey: string;
  source: GameCopySource;
  draft: NewBoxDraft;
  questions: CustomField[];
  excludePreviousGiftees: boolean;
  newKey: string;
  editingTheme: boolean;
  at: number;
}
let prepareReturn: (() => string | null) | null = null;
export function registerCopyGameReturn(prepare: () => string | null): () => void {
  prepareReturn = prepare;
  return () => { if (prepareReturn === prepare) prepareReturn = null; };
}
export function prepareCopyGameReturn(): string | null {
  return prepareReturn?.() ?? null;
}
export function saveCopyGameDraft(draft: CopyGameDraft): string | null {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(draft));
    const url = new URL(window.location.href);
    url.searchParams.set('resumeCopy', draft.sourceKey);
    return url.href;
  } catch { return null; }
}
export function readCopyGameDraft(userId: number, sourceKey: string): CopyGameDraft | null {
  try {
    const value = JSON.parse(sessionStorage.getItem(KEY) || 'null') as CopyGameDraft | null;
    if (value?.userId === userId && value.sourceKey === sourceKey && value.at <= Date.now() && Date.now() - value.at < 86400000 && value.draft && Array.isArray(value.questions)) return value;
  } catch { /* Missing or invalid local draft. */ }
  return null;
}
export function clearCopyGameDraft(): void {
  try { sessionStorage.removeItem(KEY); } catch { /* Optional storage. */ }
}
